import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions, mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/panier.svg';

var CustomProductAddToCartModal = () => import(
/* webpackMode: "eager" */
'~/components/molecules/Product/Modal/CustomProductAddToCartModal.vue');

export default {
  name: 'TheCartSection',
  components: {
    CustomProductAddToCartModal
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    products: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      showModal: false
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),
  methods: _objectSpread(_objectSpread({}, mapActions({
    addCart: 'cart/add'
  })), {}, {
    openLayer() {
      this.$root.$emit('open-layer', {
        state: true,
        name: 'LayerAddToCart',
        products: this.products
      });
      return false;
    },

    addToCart() {
      var _this = this;

      return _asyncToGenerator(function* () {
        try {
          _this.openLayer();

          if (_this.products[0]) {
            yield _this.addCart({
              reference: _this.products[0].reference,
              referenceEncoded: btoa(_this.products[0].reference),
              quantity: 1
            });
          }

          if (_this.products[1]) {
            yield _this.addCart({
              reference: _this.products[1].reference,
              referenceEncoded: btoa(_this.products[1].reference),
              quantity: 1
            });
          }
        } catch (err) {
          _this.$logger.error(err);
        }
      })();
    },

    closeAction() {
      this.showModal = false;
    }

  })
};